export default __webpack_public_path__ + "static/media/peep-20.0dba6af8.svg";